import { Pipe, PipeTransform } from '@angular/core';
import { EventInterface } from '@shared/interfaces/event.interface';

@Pipe({
  name: 'eventRegisterTooltip',
  standalone: true,
})
export class EventRegisterTooltipPipe implements PipeTransform {
  transform(event: EventInterface): string {
    if (event.isCancelled) {
      return 'UI.Event.Cancelled';
    } else if (event.isPassedEvent) {
      return 'UI.Event.AlreadyPassed';
    } else if (event.isFullyBooked) {
      return 'UI.Event.FullyBooked';
    } else {
      return event.showExternalRegistration
        ? 'UI.Event.ExternalRegistration'
        : 'UI.Event.Register';
    }
  }
}

@Pipe({
  name: 'eventRegisterBtnDisabled',
  standalone: true,
})
export class EventRegisterBtnDisabledPipe implements PipeTransform {
  transform(event: EventInterface): boolean {
    return event.isFullyBooked || event.isPassedEvent || event.isCancelled;
  }
}
